import Loader from "../../../components/Loader";

const DashboardNone = () => {
    return (
        <div className="flex text-black items-center justify-center h-[50vh]">
            <div className="flex gap-y-5 flex-col items-center  text-[min(10vw,50px)]">
                Cooming soon
                <Loader />
            </div>
        </div>
    );
};

export default DashboardNone
